const ar = {
  siteName: "أكّوزاي يابي لمواد البناء",
  siteNameShort: "أكّوزاي يابي",

  // نصوص الواجهة (الأزرار، تسميات قارئ الشاشة، الحالات الفارغة)
  ui: {
    close: "إغلاق",
    back: "رجوع",
    previous: "السابق",
    next: "التالي",
    menu: "القائمة",
    openMenu: "فتح القائمة",
    closeMenu: "إغلاق القائمة",
    logoAlt: "أكّوزاي يابي لمواد البناء",
    dealerLogoAlt: "شعار الوكالة",
    whatsapp: "راسلنا عبر واتساب",
    productCategories: "فئات المنتجات",
    subProducts: "المنتجات الفرعية",
    subCategoryNotFound: "الفئة الفرعية غير موجودة",
    emptySubCategory: "لا توجد منتجات في هذه الفئة الفرعية.",
    code: "الرمز",
  },

  homeNavbar: "الصفحة الرئيسية",
  chooseLanguage: "اختر اللغة",
  products: "المنتجات",
  corporate: "الشركة",
  affiliates: "شركاتنا التابعة",
  dealerships: "وكلاؤنا",
  newsNavbar: "الأخبار",
  storesFooter: "معارضنا",
  search_placeholder: "ابحث عن منتج...",
  contactNavbar: "اتصل بنا",
  searchPlaceholder: "ابحث عن منتج...",
  favorites: {
    title: "مفضلاتي",
    emptyMessage: "لا توجد منتجات في المفضلة.",
  },
  navbar: {
    searching: "جارٍ البحث…",
    suggestCategories: "الفئات",
    suggestProducts: "المنتجات",
    seeAllResults: "عرض كل النتائج ({{count}})",
    searchPlaceholder: "اكتب اسم المنتج الذي تبحث عنه…",
    search: "بحث",
    callUs: "اتصل بنا",
    myCart: "سلتي",
    allCategories: "جميع الفئات",
    cats: {
      insaat: "مواد البناء",
      hirdavat: "الخردوات",
      elAletleri: "العدد اليدوية",
      boya: "الدهانات",
      yapiKimyasallari: "كيماويات البناء",
      tesisat: "السباكة",
      banyo: "الحمام والخلاطات",
      elektrik: "الكهرباء",
      makinalar: "آلات البناء",
      kesme: "القطع والثقب",
    },
  },
  topBanner: {
    message:
      "akkuzey@hotmail.com | ‎+90 537 798 11 29‎ | إسطنبول GMT+3 | الإثنين–السبت (08:00–20:00) | الأحد (11:00–18:30)",
  },
  subMenus: {
    corporate: {
      about: "من نحن",
      contact: "اتصل بنا",
      qualityPolicy: "سياسة الجودة",
      complaints: "نموذج الشكاوى والاقتراحات",
      faq: "الأسئلة الشائعة",
    },
    affiliates: {
      construction: "أكّوزاي للإنشاءات",
      automotive: "أكّوزاي للسيارات",
    },
  },
  home: {
    featuredBrandsEyebrow: "علامات مميزة",
    featuredBrandsTitle: "العلامات التي تثق بها بنقرة واحدة",
    brandProductCount: "{{count}} منتج",
    newArrivalsEyebrow: "وصل حديثاً",
    newArrivalsTitle: "منتجات أضيفت مؤخراً إلى الكتالوج",
    seeCatalog: "عرض الكتالوج كاملاً",
    viewDetails: "عرض التفاصيل",
    hero: {
      eyebrow: "مواد البناء منذ 1972",
      title: "من الحمّام إلى الأدوات، توريد متكامل من مصدر واحد.",
      subtitle:
        "منذ أكثر من نصف قرن، توفّر أكّوزاي يابي منتجات البناء والسباكة والأدوات ومستلزمات الحمّام والمطبخ، بالجملة والتجزئة، من زيتون بورنو في إسطنبول.",
      ctaPrimary: "تصفّح المنتجات",
      ctaSecondary: "تواصل معنا",
      stats: {
        foundedValue: "1972",
        foundedLabel: "سنة التأسيس",
        dealersValue: "+40",
        dealersLabel: "وكالة معتمدة",
        storesValue: "2",
        storesLabel: "متجر · إسطنبول",
      },
    },
    brands: {
      title: "وكالاتنا المعتمدة",
      link: "عرض الكل",
    },
    wholesale: {
      eyebrow: "البيع بالجملة",
      title: "طوب وإسمنت بالجملة، يُسلَّم إلى موقع مشروعك.",
      subtitle:
        "نوفّر الطوب والإسمنت ومواد البناء الأساسية بأسعار الجملة، مع التسليم المباشر إلى موقع البناء. اطلب عرض سعر وفق الكميات وجدول التسليم لديك.",
      items: {
        brick: "الطوب",
        brickNote: "مفرّغ ومصمت وخرسانة خلوية",
        cement: "الإسمنت",
        cementNote: "معبأ وسائب",
        delivery: "التسليم في الموقع",
        deliveryNote: "شحن يتوافق مع جدول المشروع",
      },
      ctaPrimary: "اطلب عرض سعر بالجملة",
      ctaSecondary: "اتصل الآن",
      phone: "+90 537 798 11 29",
    },
    cta: {
      title: "لنختر معًا المواد المناسبة لمشروعك.",
      subtitle:
        "تواصل معنا للحصول على معلومات المنتجات والمخزون والأسعار، أو قم بزيارة متاجرنا.",
      primary: "تواصل معنا",
      secondary: "متاجرنا",
    },
    campaigns: {
      showerSets: {
        title: "موسم جديد لأطقم الدش",
        brand: "VitrA · ECA · Creavit",
      },
      paintRollers: {
        title: "رولات وفرش الدهان",
        brand: "Dekor",
      },
      sealants: {
        title: "سيليكون ومعاجين ورغوة التركيب",
        brand: "Selsil",
      },
      basinMixers: {
        title: "تشكيلة واسعة من خلاطات المغسلة",
        brand: "ECA · VitrA · Creavit",
      },
      interiorPaints: {
        title: "دهانات داخلية",
        brand: "Filli Boya · Polisan · Marshall",
      },
      bathroomKitchen: {
        title: "تميّز في حمامك ومطبخك",
        brand: "منتجات فاخرة",
      },
      bathroomAccessories: {
        title: "إكسسوارات الحمام والمزيد",
        brand: "أسعار مخفّضة",
      },
      modernAccessories: {
        title: "إكسسوارات عصرية",
        brand: "أفضل الأسعار",
      },
      bathroomCabinets: {
        title: "مئات الخيارات من خزائن الحمام",
        brand: "ماركات عالمية",
      },
      selsil: {
        title: "أي نوع من سيلسيل تبحث عنه؟",
        brand: "اعثر على ما تحتاجه",
      },
      sprayPaint: {
        title: "مئات ألوان بخاخات الدهان!",
        brand: "جودة قصوى",
      },
    },
  },
  bathroomAccessories: {
    title: "إكسسوارات الحمام",
    products: {
      soapDish: "صحن صابون",
      towelHolder: "حامل منشفة",
      emergencySupportShelf: "رف زاوي مع حامل منشفة",
      cornerSoapDish: "رف صابون زاوية ثلاثي – أبيض",
    },
  },
  bathroomCabinets: {
    title: "خزائن الحمام",
    products: {
      firdevsSet: "طقم خزانة حمام فيرديفس",
      klasikSet: "طقم خزانة حمام كلاسيكي",
      asyaSet: "طقم خزانة حمام آسيا",
      quadrumAsma: "خزانة حمام معلّقة Quadrum",
    },
  },
  bathroomKitchen: {
    title: "خلاطات الحمام والمطبخ",
    products: {
      begonyaShowerSet: "طقم دش علوي بيغونيا – كروم",
      spiralKitchenFaucet: "خلاط مطبخ مرن",
      ritaSinkFaucet: "خلاط مغسلة Rita",
      ritaBathFaucet: "خلاط حمام Rita",
      laraBlackSinkFaucet: "خلاط مغسلة Lara Black",
      laraBlackBathFaucet: "خلاط حمام Lara Black",
      alyaSinkFaucet: "خلاط مغسلة Alya",
      alyaBathFaucet: "خلاط حمام Alya",
    },
    barcode: "الباركود",
    code: "رمز المنتج",
    brand: "العلامة التجارية",
    color: "اللون",
    colors: {
      chrome: "كروم",
      black: "أسود",
    },
  },
  stores: {
    title: "معارضنا",
    subtitle: "تفضّل بزيارة معارضنا لتجربة جودة خدماتنا ومنتجاتنا.",
    map: "الخريطة",
    istanbul: {
      city: "إسطنبول",
      name: "معرض إسطنبول",
      address: "Çırpıcı, 75/2. Sk. No:109, Zeytinburnu / إسطنبول",
      phone: "+90 537 798 11 29",
      email: "akkuzey@hotmail.com",
      hours: "الاثنين–السبت: 08:00–20:00، الأحد: 11:00–18:30",
    },
    ankara: {
      city: "إسطنبول",
      name: "فرع إسطنبول",
      address: "Beştelsiz, 1. Yol Sk. No:7, Zeytinburnu / إسطنبول",
      phone: "+90 537 798 11 29",
      email: "akkuzey@hotmail.com",
      hours: "الاثنين–السبت: 08:00–20:00، الأحد: 11:00–18:30",
    },
  },
  modernAccessories: {
    title: "إكسسوارات حديثة",

    products: {
      suspendedCeilingPanel: "لوح سقف معلق عازل للصوت",
      modernDoorHandleBlack: "مقبض باب حديث باللون الأسود غير اللامع",
      modernDoorHandleChrome: "مقبض باب حديث بكروم ساتان",
      sensorSoapDispenser: "موزع صابون أوتوماتيكي يعمل بالمستشعر",
    },
  },

  selsil: {
    title: "دليل منتجات سيلسيل",
    barcode: "الباركود",
    code: "الرمز",
    brand: "العلامة التجارية",
    color: "اللون",
    colors: {
      white: "أبيض",
      black: "أسود",
      red: "أحمر",
      green: "أخضر",
      blue: "أزرق",
      gray: "رمادي",
      lightGray: "رمادي فاتح",
      transparent: "شفاف",
    },
    products: {
      siliconeTransparent: { name: "سيليكون شفاف 280 غ" },
      siliconeWhite: { name: "سيليكون أبيض 280 غ" },
      siliconeBlack: { name: "سيليكون أسود 280 غ" },
      masticWhite: { name: "معجون أبيض 450 غ" },
      foam600gr: { name: "رغوة 600 غ" },
      rtvHeatSilicone: { name: "سيليكون مقاوم للحرارة – أحمر" },
      miraculouspackage: {
        name: "سيلسيل باك منظف الرغوة المعجزة 500 مل",
      },
      SelsilCleaning: {
        name: "سيلسيل باك المنظف المعجزة متعدد الاستخدامات 500 غ",
      },
      StainRemover: {
        name: "سيلسيل باك بخاخ مزيل البقع 150 مل",
      },
      puMasticBlack: { name: "معجون PU أسود" },
      puMasticGray: { name: "معجون PU رمادي" },
      puMasticWhite: { name: "معجون PU أبيض" },
      multiPurposeSpray: { name: "بخاخ متعدد الاستخدامات 400 مل" },
      selsilSprayB: { name: "سيلسيل بخاخ B ‏400 مل" },
    },
  },
  sprayPaint: {
    title: "كتالوج بخاخات الدهان",
    productName: "بخاخ دهان أكتشالي 400 مل {{color}}",
    code: "الرمز",
    unit: "الوحدة",
    category: "الفئة",
    color: "اللون",
    categories: { paint: "دهان" },
    colors: {
      white: "أبيض",
      black: "أسود",
      red: "أحمر",
      green: "أخضر",
      blue: "أزرق",
      gray: "رمادي",
      lightGray: "رمادي فاتح",
      lightBrown: "بني فاتح",
      orange: "برتقالي",
      lightGreen: "أخضر فاتح",
      taxiYellow: "أصفر تاكسي",
      bordeaux: "برغندي",
      purple: "بنفسجي",
      lightBlue: "أزرق فاتح",
      beadBlue: "أزرق لؤلؤي",
      turquoise: "تركواز",
      navyBlue: "كحلي",
      glossWhite: "أبيض لامع",
      beige: "بيج",
      chromeYellow: "أصفر كروم",
      brown: "بني",
      glossBlack: "أسود لامع",
      matteWhite: "أبيض مطفي",
      matteBlack: "أسود مطفي",
      trafficWhite: "أبيض المرور",
      pearlWhite: "أبيض لؤلؤي",
      mossGreen: "أخضر طحلب",
      anthracite: "أنتراسيت",
      gloss: "لامع",
      matte: "مطفي",
      saten: "ساتان",
      darkGray: "رمادي داكن",
      smoke: "فحمي",
      bronze: "برونزي",
      lightAluminium: "ألومنيوم فاتح",
      mediumGray: "رمادي متوسط",
      bumperBlack: "أسود المصد",
      bumperWhite: "أبيض المصد",
      enamelStoveBrown: "دهان مينا للمدفأة بني",
      metallicBlack: "أسود ميتاليك",
      metallicYellow: "أصفر ميتاليك",
      metallicBlue: "أزرق ميتاليك",
      grayWhite: "أبيض رمادي",
      oxideYellow: "أصفر أكسيد",
      fuchsia: "فوشيا",
      machineRed: "أحمر الآلات",
      scarlet: "قرمزي",
      fluorescentYellow: "أصفر فلوري",
      fluorescentLilac: "ليلكي فلوري",
      fluorescentRed: "أحمر فلوري",
      fluorescentDarkRed: "أحمر داكن فلوري",
      fluorescentOrange: "برتقالي فلوري",
      plasticPrimer: "برايمر للأسطح البلاستيكية",
    },
    products: {
      akcaliSpray400ml: "بخاخ دهان Akçalı ‏400 مل",
      akcaliVarnish400ml: "ورنيش Akçalı ‏400 مل",
      akcaliBumperPaint400ml: "دهان صدام السيارة Akçalı ‏400 مل",
      akcaliWheelPaint400ml: "دهان جنوط السيارة Akçalı ‏400 مل",
    },
  },

  dealershipsPage: {
    title: "وكلاؤنا",
    subtitle: "يمكنك الوصول بسهولة إلى منتجاتنا عبر شبكة وكلائنا الواسعة.",
    brands: {
      abb: "ABB",
      armaş: "Armaş",
      baylan: "Baylan",
      ecesan: "Ecesan",
      fluke: "Fluke",
      isonem: "Isonem",
      kalekim: "Kalekim",
      karbon: "Karbon",
      makel: "Makel",
      metoba: "Metoba",
      optimum: "Optimum",
      pelsan: "Pelsan",
      pimtaş: "Pimtaş",
      polisan: "Polisan",
      selsil: "Selsil",
      sista: "Sista",
      viko: "Viko",
      vitra: "Vitra",
      yaparlar: "Yaparlar",
      yds: "YDS",
      alarko: "Alarko",
      askaynak: "Askaynak",
      ayvaz: "Ayvaz",
      beybi: "Beybi",
      bmex: "BMEX",
      bonuspan: "Bonuspan",
      bosh: "Bosch",
      çayırva: "Çayırva",
      dekor: "Dekor",
      dewalt: "Dewalt",
      duyar: "Duyar",
      ebitt: "Ebitt",
      eca: "ECA",
      feica: "Feica",
      fırat: "Fırat",
      honey: "Honeywell",
      kale: "Kale",
      knipex: "Knipex",
      köse: "Köse",
      metresan: "Metresan",
      marshall: "Marshall",
      stanley: "Stanley",
      tekno: "Tekno",
      turkuaz: "Turkuaz",
      pakkens: "Pakkens",
      rothenberg: "Rothenberg",
      sonneflex: "Sonneflex",
      sumak: "Sumak",
      yalteks: "Yalteks",
    },
  },
  product: {
    zoom: "تكبير",
    close: "إغلاق",
    share: "مشاركة",
    linkCopied: "تم نسخ الرابط",
    notFound: "المنتج غير موجود.",
    backToCatalog: "العودة إلى الكتالوج",
    options: "الخيارات",
    askWhatsapp: "اسأل عبر واتساب",
    whatsappText: "مرحباً، أود معرفة السعر والتوفر للمنتج {{ad}}{{secenek}}.",
    call: "اتصل بنا",
    description: "وصف المنتج",
    autoDescription: "{{ad}} هو منتج من {{marka}} ضمن مجموعة {{kategori}}.",
    optionsSentence: "متوفر بـ {{sayi}} خيارات: {{liste}}.",
    priceInfo: "تواصل معنا عبر واتساب أو الهاتف لمعرفة السعر والتوفر؛ نقدم أسعاراً خاصة لطلبات الجملة.",
    metaDescription: "{{ad}} — {{marka}} {{kategori}}. احصل على السعر والتوفر من أكّوزي لمواد البناء.",
    related: "منتجات مشابهة",
    viewAll: "عرض الكل",
    trust: {
      wholesaleTitle: "جملة وتجزئة",
      wholesale: "أسعار خاصة للمواقع والمقاولين",
      sinceTitle: "منذ 1972",
      since: "توريد مواد البناء في زيتين بورنو",
      quoteTitle: "عرض سعر سريع",
      quote: "أرسل قائمتك برسالة واتساب واحدة",
    },
  },
  recent: {
    eyebrow: "تابع من حيث توقفت",
    title: "المنتجات التي شاهدتها مؤخراً",
    clear: "مسح القائمة",
  },
  calc: {
    materialList: "قائمة المواد",
    print: "طباعة / PDF",
    copyLink: "نسخ الرابط",
    suggested: "منتجات مقترحة لهذا العمل",
    stepArea: "المساحة والقياسات",
    stepProduct: "المنتج والتطبيق",
    approx: "تقريباً",
    tabsHint: {
      boya: "لترات وعبوات",
      duvar: "قطع ومونة",
      seramik: "علب، لاصق، ترويب",
      beton: "م³ وإسمنت",
      alci: "عدد الأكياس",
      alcipan: "ألواح، بروفيلات، براغي",
    },
    tile: {
      area: "المساحة المراد تبليطها",
      straight: "تركيب مستقيم (هدر 10%)",
      diagonal: "تركيب قطري (هدر 15%)",
      stepTile: "مقاس البلاط",
      tileWidth: "العرض",
      tileHeight: "الطول",
      thickness: "السماكة",
      boxM2: "مساحة العلبة",
      boxHint: "مكتوبة على العلبة (مثلاً 1.44 م² لمقاس 60×60)",
      stepAdhesive: "اللاصق والترويب",
      adhesive: "استهلاك اللاصق",
      adhesiveHint: "5–7 كغ/م² للمقاسات الكبيرة، 3–4 كغ/م² للصغيرة",
      joint: "عرض الفاصل",
      result: "العلب المطلوبة",
      boxes: "علبة",
      tiles: "البلاط",
      adhesiveItem: "لاصق السيراميك",
      groutItem: "مادة الترويب",
      browse: "تصفح المواد اللاصقة",
      whatsapp: "مرحباً، حسبت بلاط {{olcu}} سم لمساحة {{alan}} م²: {{adet}} قطعة ({{kutu}} علبة)، {{torba}} كيس لاصق و{{derz}} كغ ترويب. هل يمكنني معرفة السعر؟",
    },
    concrete: {
      thickness: "السماكة",
      type: "التطبيق",
      type_sap: "طبقة تسوية (شاب)",
      type_grobeton: "خرسانة نظافة (C16)",
      type_c25: "خرسانة C25",
      type_c30: "خرسانة C30",
      dosage: "جرعة الإسمنت",
      dosageHint: "إسمنت لكل م³؛ عدّلها حسب المشروع",
      result: "الإسمنت المطلوب",
      cementBags: "كيس",
      cement: "الإسمنت",
      sand: "الرمل",
      aggregate: "الرمل والحصى",
      readyMix: "إذا طلبت خرسانة جاهزة",
      readyMixNote: "حجم الطلب",
      volume: "الحجم",
      browse: "تصفح الإسمنت",
      whatsapp: "مرحباً، حسبت {{hacim}} م³ من {{tip}}: {{torba}} كيس ({{kg}} كغ) إسمنت. هل يمكنني معرفة السعر؟",
    },
    drywall: {
      stepSystem: "نظام الجدار",
      faces: "الأوجه المكسوة",
      oneFace: "وجه واحد",
      twoFaces: "وجهان",
      layers: "طبقات الألواح",
      single: "طبقة واحدة",
      double: "طبقتان",
      spacing: "المسافة بين القوائم",
      result: "الألواح المطلوبة",
      boards: "لوح",
      boardItem: "لوح جبس",
      cProfile: "بروفيل C (قائم)",
      studs: "قائم",
      uProfile: "بروفيل U (أرضي-سقفي)",
      screws: "براغي الجبس",
      tape: "شريط الفواصل",
      jointFiller: "معجون الفواصل",
      browse: "تصفح أنظمة الجبس بورد",
      whatsapp: "مرحباً، حسبت جدار جبس بمساحة {{alan}} م²: {{levha}} لوح، {{c}} بروفيل C، {{u}} بروفيل U، {{vida}} برغي. هل يمكنني معرفة السعر؟",
    },
    eyebrow: "حاسبة المواد",
    title: "كم تحتاج من المواد؟",
    subtitle: "أدخل القياسات واحصل على قائمة مفصلة بالمواد للدهان والطوب والبلاط والخرسانة والجبس والجبس بورد. اطبعها أو أرسلها عبر واتساب للحصول على عرض سعر.",
    tabs: {
      seramik: "السيراميك والبلاط",
      beton: "الخرسانة والتسوية",
      alcipan: "جدار الجبس بورد",
      boya: "الدهان",
      duvar: "الطوب والخرسانة الخلوية",
      alci: "الجبس واللياسة",
    },
    askQuote: "اطلب سعر هذه الكمية",
    disclaimer: "النتائج تقديرية وقد تختلف حسب السطح والمنتج.",
    width: "العرض",
    length: "الطول",
    height: "الارتفاع",
    openings: "مساحة الأبواب / النوافذ",
    openingsHint: "مساحة تُطرح من الحساب",
    netArea: "المساحة الصافية",
    liter: "لتر",
    pieces: "قطعة",
    waste: "نسبة الهدر",
    wasteHint: "للكسر والقص",
    viewProduct: "عرض المنتج",
    paint: {
      item: "الدهان",
      primer: "الأساس (برايمر)",
      primerNote: "طبقة واحدة، ~12 م²/لتر",
      addPrimer: "احسب الأساس أيضاً",
      mode_oda: "حسب أبعاد الغرفة",
      mode_alan: "حسب المساحة الكلية",
      includeCeiling: "دهان السقف أيضاً",
      area: "المساحة المراد دهانها",
      coats: "عدد الطبقات",
      coatUnit: "طبقة",
      coverage: "معدل التغطية",
      coverageHint: "من ملصق المنتج؛ عادة 8–12 م²/لتر",
      result: "الدهان المطلوب",
      packages: "العبوات المقترحة",
      browse: "تصفح الدهانات",
      whatsapp: "مرحباً، حسبت {{kat}} طبقات دهان لمساحة {{alan}} م²: حوالي {{litre}} لتر ({{paket}}). هل يمكنني معرفة السعر؟",
    },
    wall: {
      mortar: "مونة البناء",
      thinMortar: "مونة لصق الخرسانة الخلوية",
      length: "طول الجدار",
      block: "الطوب / البلوك",
      custom: "إدخال القياس يدوياً",
      blockLength: "طول البلوك",
      blockHeight: "ارتفاع البلوك",
      joint: "سماكة الفاصل",
      jointHint: "حوالي 10 مم للطوب و3 مم للخرسانة الخلوية",
      result: "العدد المطلوب",
      perM2: "لكل م²",
      browse: "تصفح الطوب والبلوك",
      whatsapp: "مرحباً، حسبت {{blok}} لجدار مساحته {{alan}} م²: حوالي {{adet}} قطعة. هل يمكنني معرفة السعر؟",
    },
    plaster: {
      type: "نوع المنتج",
      type_makine: "جبس لياسة آلي",
      type_perlitli: "جبس بيرلايت (يدوي)",
      type_saten: "جبس تشطيب ساتان",
      area: "مساحة التطبيق",
      thickness: "السماكة",
      consumption: "الاستهلاك",
      consumptionHint: "قيمة تقريبية؛ عدّلها حسب النشرة الفنية",
      bag: "الكيس",
      result: "الأكياس المطلوبة",
      bags: "كيس",
      total: "الإجمالي",
      bagSize: "وزن الكيس",
      browse: "تصفح الجبس واللياسة",
      whatsapp: "مرحباً، حسبت {{tip}} ({{kalinlik}} مم) لمساحة {{alan}} م²: حوالي {{torba}} كيس ({{kg}} كغ). هل يمكنني معرفة السعر؟",
    },
    navbarItem: "الحاسبة",
    teaserEyebrow: "أداة مجانية",
    teaserTitle: "احسب كمية المواد التي تحتاجها",
    teaserText: "احسب كمية الدهان والطوب والجبس حسب قياساتك وأرسل النتيجة عبر واتساب للحصول على عرض سعر.",
    teaserCta: "ابدأ الحساب",
  },
  shop: {
    searchPlaceholder: "ابحث عن منتج…",
    searchAllPlaceholder: "ابحث في جميع المنتجات…",
    searchResultsFor: "نتائج البحث عن «{{q}}»",
    searchNoResult: "لا توجد منتجات مطابقة لبحثك.",
    brandProducts: "منتجات {{marka}}",
    categoryProducts: "منتجات هذه الفئة",
    cart: "السلة",
    cartTitle: "قائمة عرض السعر",
    cartEmpty: "قائمتك فارغة.",
    cartEmptyHint: "استخدم «أضف إلى السلة» بجانب المنتج لإنشاء قائمة طلب السعر.",
    addToCart: "أضف إلى السلة",
    added: "تمت الإضافة",
    remove: "إزالة",
    clear: "إفراغ القائمة",
    selectSize: "اختر الحجم",
    subCategories: "الفئات الفرعية",
    brands: "العلامات التجارية",
    allBrands: "الكل",
    clearFilters: "مسح عوامل التصفية",
    productCount: "{{count}} منتج",
    tileZoom: "عرض الصورة",
    tileExplore: "استكشف",
    noResult: "لا توجد منتجات مطابقة لعوامل التصفية.",
    whatsappSend: "اطلب عرض سعر عبر واتساب",
    whatsappIntro: "مرحباً، أود الحصول على معلومات وأسعار المنتجات التالية:",
    whatsappOutro: "شكراً لكم.",
    quantity: "الكمية",
    productFeatures: {
      "mukemmel-inceltici": "مخفف ممتاز",
      "su-bazli": "أساسه مائي",
      "makinede-renklendirilebilen-beyaz": "أبيض قابل للتلوين آلياً",
      "yuksek-kaplama-alani": "مساحة تغطية عالية",
      "yuzey-hatalarini-gizler": "يخفي عيوب السطح",
      "uzun-omurlu": "طويل العمر",
      "dusuk-koku": "رائحة خفيفة",
      "rahat-uygulama": "سهل التطبيق",
      "lekeleri-gizler": "يخفي البقع",
      "yuksek-renk-dayanimi": "ثبات لوني عالٍ",
      "yuksek-ortuculuk": "تغطية عالية",
      "uzun-sureli-beyazlik": "بياض يدوم طويلاً",
      "hizli-kuruyan": "سريع الجفاف",
      "tutunmayi-kuvvetlendirir-ve-son-katin-da": "يقوّي الالتصاق ويزيد متانة الطبقة النهائية",
      "kolay-temizlenir": "سهل التنظيف",
      "leke-dayanimli": "مقاوم للبقع",
      silinebilir: "قابل للمسح",
      "pas-onleyici": "مانع للصدأ",
      "coklu-yuzeyler-icin": "لأسطح متعددة",
      "hazirlar-korur-ve-guclendirir": "يهيّئ ويحمي ويقوّي",
      "basit-ve-kolay-yuzey-hazirligi": "تحضير سطح بسيط وسهل",
      "astar-gerektirmez": "لا يحتاج برايمر",
      "guclendirilmis-sizdirmazlik": "إحكام معزز",
      "toz-tutmaz": "لا يجمع الغبار",
      "uzun-sureli-dayanim": "متانة طويلة الأمد",
      "kuf-olusumuna-direncli": "مقاوم للعفن",
      "ultra-yapisma": "التصاق فائق",
      "sicratma-ve-damlatma-yapmaz": "بلا رذاذ أو تنقيط",
      "uv-dayanikli": "مقاوم للأشعة فوق البنفسجية",
      "her-turlu-hava-sartlarina-dayanikli": "مقاوم لجميع الظروف الجوية",
      "scuff-mark-resistant-teknolojisi": "تقنية Scuff Mark Resistant",
      "guclu-cizilme-direnci": "مقاومة قوية للخدش",
      "15-kat-daha-fazla-silinebilir": "قابل للمسح 15 ضعفاً",
      "ultra-yikanabilir": "قابل للغسل بشكل فائق",
      "ultra-kapatici": "تغطية فائقة",
      "5-kat-daha-fazla-silinebilir": "قابل للمسح 5 أضعاف",
      "kokusuz-ve-cevre-dostu": "بلا رائحة وصديق للبيئة",
      "smartsil-teknolojisi": "تقنية SmartSil",
      yikanabilir: "قابل للغسل",
      "sicratmaz-kolay-uygulanir": "بلا رذاذ، سهل التطبيق",
    },
  },
  notFound: {
    title: "الصفحة التي تبحث عنها غير موجودة.",
    subtitle:
      "ربما تغيّر العنوان أو كُتب بشكل خاطئ. يمكنك المتابعة من الروابط أدناه.",
    home: "العودة إلى الصفحة الرئيسية",
  },

  news: {
    title: "الأخبار",
    subtitle:
      "تعرّف على أحدث أخبار القطاع ومتابعة ظهور أكّوزاي في وسائل الإعلام.",
    readMore: "اقرأ المزيد",
    showLess: "عرض أقل",
    articles: {
      newTools: {
        title: "إطلاق جيل جديد من الأدوات اليدوية",
        date: "20 سبتمبر 2025",
        description:
          "أدوات يدوية مبتكرة بخصائص مريحة وعمر استخدام طويل تدخل السوق بقوة.",
      },
      energyEfficiency: {
        title: "عصر الكفاءة في الأدوات الكهربائية",
        date: "15 سبتمبر 2025",
        description:
          "الأدوات الكهربائية الجديدة تستهلك طاقة أقل بنسبة 30% مع أداء أفضل.",
      },
      exportRecord: {
        title: "تركيا تحقق رقماً قياسياً في صادرات الأدوات",
        date: "10 سبتمبر 2025",
        description:
          "القطاع يسجل نمواً كبيراً في أوروبا والشرق الأوسط خلال النصف الأول من 2025.",
      },
      measurementDevices: {
        title: "اتجاهات جديدة في أجهزة القياس الذكية",
        date: "05 سبتمبر 2025",
        description:
          "أجهزة القياس بالليزر توفّر دقة عالية وسرعة في مجالات البناء والهندسة.",
      },
    },
  },

  qualityPolicy: {
    title: "سياسة الجودة",
    policies: {
      customerSatisfaction: {
        title: "رضا العملاء",
        description:
          "نولي أولوية لفهم احتياجات العملاء وتقديم خدمة عالية الجودة.",
      },
      reliability: {
        title: "الاعتمادية",
        description: "نعمل مع كبار المصنعين ونلتزم بمواعيد التسليم.",
      },
      ethicalValues: {
        title: "القيم الأخلاقية",
        description: "الشفافية، النزاهة، والعمل الجماعي من مبادئنا الأساسية.",
      },
      customerFocus: {
        title: "التركيز على العميل",
        description:
          "نحلل احتياجات العملاء بدقة ونوفر منتجات عالية الجودة وبأسعار مناسبة.",
      },
      quickSolution: {
        title: "حلول سريعة",
        description: "فريقنا يقدم حلولاً سريعة وفعّالة لجميع المشكلات.",
      },
    },
  },

  viewStores: "عرض المعارض",

  footer: {
    description:
      "أكّوزاي تلتزم بتقديم الجودة والموثوقية والاستدامة في خدماتها.",
    contactButton: "اتصل بنا",
    corporate: {
      title: "الشركة",
      about: "من نحن",
      contact: "اتصل بنا",
      complaints: "نموذج الشكاوى",
      faq: "الأسئلة الشائعة",
    },
    quickMenu: { title: "قائمة سريعة" },
    map: { title: "موقعنا" },
    copyright: "© {{year}} Akkuzey لمواد البناء. جميع الحقوق محفوظة.",
    contactInfo: {
      title: "معلومات الاتصال",
      address: "Çırpıcı Mah. 75/2 Sk. No:109/1, Zeytinburnu / إسطنبول",
      directions: "احصل على الاتجاهات",
      weekdays: "الإثنين – السبت: 08:00 – 20:00",
      sunday: "الأحد: 11:00 – 18:30",
    },
    brandsStrip: {
      title: "علامات تجارية مميزة",
      subtitle: "انقر على علامة تجارية لعرض جميع منتجاتها.",
    },
    social: {
      whatsapp: "راسلنا عبر واتساب",
      instagram: "تابعنا على إنستغرام",
    },
  },

  faq: {
    title: "الأسئلة الشائعة",
    subtitle: "اطّلع على أكثر الأسئلة تكراراً",
    contactPrompt: "هل لديك سؤال لم تجد إجابته هنا؟",
    contactButton: "الذهاب إلى نموذج الاتصال",
    questions: {
      qualityStandards: {
        question: "ما هي معايير الجودة التي تتوافق معها منتجاتكم؟",
        answer: "جميع منتجاتنا تتوافق مع معايير TSE والمعايير الدولية.",
      },
      technicalSupport: {
        question: "هل يمكنني الحصول على دعم فني؟",
        answer: "نعم، يقدم فريقنا الدعم الفني الكامل لجميع المنتجات.",
      },
      bulkSupply: {
        question: "هل توفرون توريداً بالجملة للمشاريع؟",
        answer: "نعم، نوفر أسعاراً خاصة للمشاريع الكبيرة.",
      },
      productCatalogs: {
        question: "كيف يمكنني الحصول على كتالوجات المنتجات؟",
        answer: "يمكنك تحميل الكتالوج من الموقع أو طلبه عبر البريد.",
      },
      customProduction: {
        question: "هل توفرون إنتاجاً مخصصاً؟",
        answer: "نعم، لبعض الفئات نوفر خيارات تصنيع خاصة.",
      },
      training: {
        question: "هل تقدمون تدريبات على استخدام المنتجات؟",
        answer: "نعم، نقدم تدريبات دورية من قبل فرق محترفة.",
      },
    },
  },

  complaintForm: {
    title: "نموذج الشكاوى والاقتراحات",
    subtitle: "ملاحظاتكم تهمنا",
    fields: {
      name: "الاسم الكامل",
      phone: "رقم الهاتف",
      orderNumber: "رقم الطلب",
      type: "النوع",
      message: "رسالتك",
    },
    placeholders: {
      name: "اكتب اسمك الكامل",
      phone: "5__ ___ __ __",
      orderNumber: "اكتب رقم الطلب",
      message: "يرجى الشرح بالتفصيل...",
    },
    types: {
      complaint: "شكوى",
      suggestion: "اقتراح",
      request: "طلب",
    },
    submit: "إرسال",
    submitting: "جاري الإرسال...",
    footerNote: "الحصول على الرد في أقرب وقت ممكن.",
  },

  about: {
    title: "من نحن",
    mainParagraph:
      "تأسست أكّوزاي عام 1972 في إسطنبول. بدأت الشركة في تجارة العدد بالجملة، واستمرت في النمو بناءً على قيم الصدق ورضا العملاء.",
    corporateDevelopment: {
      title: "التطور المؤسسي",
      description:
        "من خلال البحث والتطوير والتوسع المستمر، تواصل أكّوزاي نموها بقيادة مؤسسها آدم أكّوزاي.",
    },
    futureVision: {
      title: "رؤيتنا المستقبلية",
      description:
        "نسعى لأن نكون علامة تجارية وطنية رائدة من خلال الاستثمار المستدام.",
    },
    quote: {
      text: `"نعمل بعزم لنترك قصة نجاح دائمة للأجيال القادمة."`,
      author: "آدم أكّوزاي — رئيس مجلس الإدارة",
    },
  },

  contact: {
    title: "اتصل بنا",
    subtitle: "فريقنا المحترف جاهز للرد على أسئلتكم ودعم مشاريعكم.",
    offices: {
      headOffice: {
        title: "المكتب الرئيسي",
        address: "Çırpıcı Mah. 75/2 Sk. No:109/1\nزيتون بورنو / إسطنبول",
        phone1Label: "هاتف 1",
        phone1: "0 (212) 415 45 11",
        phone2Label: "هاتف 2",
        phone2: "0 (537) 798 11 29",
        emailLabel: "البريد الإلكتروني",
        email: "akkuzey@hotmail.com",
      },
      branch: {
        title: "الفرع",
        address: "Beştelsiz Mah. 5. Yol Sk. No:7/A\nزيتون بورنو / إسطنبول",
        phoneLabel: "هاتف",
        phone: "0 (212) 665 28 72",
      },
    },
    quickContact: {
      title: "اتصال سريع",
      phone: { label: "خط دعم العملاء", number: "+90 212 415 45 11" },
      whatsapp: { label: "عبر واتساب", action: "إرسال رسالة" },
      email: { label: "إرسال بريد", address: "akkuzey@hotmail.com" },
    },
  },
};

export default ar;
